import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = () => ({
	sandboxDetails: {
		projectTitle: null,
		editorContent: null,
		selectedDifficultOptions: null,
		selectedCategory: null,
		selectedSubCategory: null,
		marks: null,
		publicAvailability: false,
		formTags: [],
		selectedTemplate: null,
		selectedCheckingMetrics: [],
	},
	appliedFilters: {
		projectStatus: null,
		category: null,
		template: null,
		name: null,
		count: 20,
		page: 0,
	},
	checkingMetrics: [],
});

const getters = {
	getSandboxDetails: (state) => state.sandboxDetails,
	getCheckingMetrics: (state) => state.checkingMetrics,
	getAppliedFilters: (state) => state.appliedFilters,
};

const actions = {};

const mutations = {
	setAppliedFilters(state, appliedFilter) {
		state.appliedFilters = { ...appliedFilter };
	},
	setCheckingMetrics(state, checkingMetrics) {
		state.checkingMetrics = checkingMetrics;
	},
	resetSandboxDetails(state) {
		state.sandboxDetails = {
			projectTitle: null,
			editorContent: null,
			selectedDifficultOptions: null,
			selectedCategory: null,
			selectedSubCategory: null,
			marks: null,
			publicAvailability: false,
			formTags: [],
			selectedTemplate: null,
			selectedCheckingMetrics: [],
		};
	},
	resetCheckingMetrics(state) {
		state.checkingMetrics = [];
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
